import { useEffect } from "react";
export default function Datenschutz() {
    useEffect(() => {
        document.title = "Datenschutz – Tuscher Helmut Betonrohrfallen";
    }, []);
    return (
        <div className="max-w-3xl mx-auto px-4 py-12 text-sm leading-relaxed">
            <h1 className="text-2xl font-semibold mb-6">Datenschutzerklärung</h1>

            <p className="mb-4">
                Der Schutz Ihrer persönlichen Daten ist mir ein besonderes Anliegen.
                Ich verarbeite Ihre Daten daher ausschließlich auf Grundlage der
                gesetzlichen Bestimmungen (DSGVO, TMG).
            </p>

            <h2 className="text-lg font-semibold mt-8 mb-2">1. Verantwortlicher</h2>
            <p className="mb-4">
                Helmut Tuscher<br />
                Hofmark 50<br />
                93326 Abensberg<br />
                Deutschland<br />
                E-Mail: info@tuscherhelmut-betonrohrfallen.de
            </p>

            <h2 className="text-lg font-semibold mt-8 mb-2">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
            <p className="mb-4">
                Personenbezogene Daten werden nur erhoben, wenn Sie mir diese im
                Rahmen einer Bestellung, Kontaktaufnahme oder Registrierung freiwillig mitteilen.
            </p>

            <h2 className="text-lg font-semibold mt-8 mb-2">3. Bestellabwicklung</h2>
            <p className="mb-4">
                Zur Abwicklung Ihrer Bestellung verarbeite ich folgende Daten:
                Name, Adresse, E-Mail-Adresse sowie Zahlungsinformationen.
                Diese Daten werden ausschließlich zur Vertragsabwicklung verwendet.
            </p>

            <h2 className="text-lg font-semibold mt-8 mb-2">4. Zahlungsdienstleister</h2>
            <p className="mb-4">
                Die Zahlungsabwicklung erfolgt über externe Zahlungsdienstleister
                (z. B. PayPal). Es gelten die Datenschutzbestimmungen des jeweiligen Anbieters.
            </p>

            <h2 className="text-lg font-semibold mt-8 mb-2">5. Server-Logfiles</h2>
            <p className="mb-4">
                Der Hosting-Provider erhebt und speichert automatisch Informationen
                in sogenannten Server-Logfiles, die Ihr Browser automatisch übermittelt.
                Diese Daten sind nicht bestimmten Personen zuordenbar.
            </p>

            <h2 className="text-lg font-semibold mt-8 mb-2">6. Cookies</h2>
            <p className="mb-4">
                Meine Website verwendet Cookies, um den Warenkorb und grundlegende
                Funktionen des Shops bereitzustellen. Cookies richten keinen Schaden an.
            </p>

            <h2 className="text-lg font-semibold mt-8 mb-2">7. Ihre Rechte</h2>
            <p className="mb-4">
                Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung,
                Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu.
            </p>

            <h2 className="text-lg font-semibold mt-8 mb-2">8. Kontakt</h2>
            <p className="mb-4">
                Wenn Sie per E-Mail Kontakt mit mir aufnehmen, werden Ihre angegebenen
                Daten zwecks Bearbeitung der Anfrage gespeichert.
            </p>

            <p className="text-slate-500 text-xs mt-8">
                Stand: {new Date().toLocaleDateString("de-DE")}
            </p>
        </div>
    );
}
